import {useQuery} from "@tanstack/react-query";
import {getItem} from "../getters/getItem.js";


export const useWizardData = (url, name,enabled = true) => {
    return useQuery({
        queryKey: [`wizard_data__${name}__${url}`],
        queryFn: () => getItem(url),
        refetchOnMount: 'always',
        enabled: enabled
    })
}